import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import { loadConfig, type AppConfig } from './configLoader' // chk for env settings

/*
loadConfig().then(config => {
  const app = createApp(App)
  app.provide('config', config) // injectable app config, useConfig()
  app.mount('#app')
})
*/

// Reusable mount function
export async function mountMyWidget(
  el: HTMLElement,
  configUrl?: string
)
{
  const config: AppConfig = await loadConfig(configUrl)

  const app = createApp(App)

  // injectable app config, usable via useConfig()
  app.provide('config', config)

  app.mount(el)
}

// auto-mount for local dev / SPA usage
const defaultEl = document.getElementById('app')
if (defaultEl) 
{
  // with default config URL
  mountMyWidget(defaultEl).catch(err =>
  {
    console.error('Failed to mount widget:', err)
  })
}

// expose it as a global for host pages
; (window as any).mountMyWidget = mountMyWidget
